import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import AlterarSenha from '@/components/AlterarSenha'
import Usuarios from '@/components/Usuarios'
import Conta from '@/components/Conta'
import Configuracoes from '@/components/Configuracoes'
import RecuperarSenha from '@/components/RecuperarSenha'
import Clientes from '@/components/Clientes'
import Equipes from '@/components/Equipes'
import Planejamentos from '@/components/Planejamentos'
import Faturas from '@/components/Faturas'
import Faturamentos from '@/components/Faturamentos'
import Contratos from '@/components/Contratos'
import NotasFiscais from '@/components/NotasFiscais'
import Visitas from '@/components/Visitas'
import OrdensServicos from '@/components/OrdensServicos'
import GerenciarAgendamentos from '@/components/GerenciarAgendamentos'
import GerenciarEquipes from '@/components/GerenciarEquipes'
import GerenciarUsuarios from '@/components/GerenciarUsuarios'
import GerenciarClientes from '@/components/GerenciarClientes'
import GerenciarPlanejamentos from '@/components/GerenciarPlanejamentos'
import DetalhesPlanejamentos from '@/components/DetalhesPlanejamentos'
import GerenciarContratos from '@/components/GerenciarContratos'
import Pagamento from '@/components/Pagamento'
import Contrato from '@/components/Contrato'
import OS from '@/components/OS'

import { isMobile } from 'mobile-device-detect';
var loggedRoute 	= "Dashboard";
var notLoggedRoute 	= "Login";

// if (!window.localStorage.getItem("_intro")) {
	// notLoggedRoute 		= "Introducao";
// }

Vue.use(Router)

const checkLogin 	= (to, from, next) => {
    var self    	= this;

    console.log("checkLogin()", to, from, next)

    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false || typeof to.meta.auth == "undefined") {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	// console.log("Esta logado e a pagina nao permite", _this);
				 	if (_this.currentRoute.params.reload == 1) {
				 		console.log("Faz reload")
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            } else {
            	// console.log("ELSE")
            	// if ()
            }

        } catch(err) {
            // return false;
        }
    }
    
 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};

var _this = new Router({
	// mode: 'history',
  	routes: [   
	    {
	      	path: '/login/',
	      	name: 'Login',
	      	meta: {
	      		title: 		"Login",
	      		auth: 		false,
	      	},
	      	component: Login,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/dashboard/',
	      	name: 'Dashboard',
	      	meta: {
	      		title: 		"Dashboard",
	      		icon: 		"la-tachometer-alt",
		      	level: 		["admin", "contratante", "prestador"],
	      		auth: 		true,
	      	},
	      	component: Dashboard,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/alterar-senha/',
	      	name: 'AlterarSenha',
	      	meta: {
	      		title: 		"Alterar senha",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "contratante", "prestador"],
	      	},
	      	component: AlterarSenha,
	      	beforeEnter: checkLogin,
	    },	    	
	    {
	      	path: '/clientes/cadastro',
	      	name: 'CadastrarClientes',
	      	meta: {
	      		title: 		"Cadastrar cliente",
	      		icon: 		"la-user-friends",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarClientes,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/clientes/editar',
	      	name: 'EditarClientes',
	      	meta: {
	      		title: 		"Editar cliente",
	      		icon: 		"la-user-friends",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarClientes,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/clientes/',
	      	name: 'Clientes',
	      	meta: {
	      		title: 		"Clientes",
	      		icon: 		"la-user-friends",
		      	level: 		["admin"],
	      		auth: 		true,
	      	},
	      	component: Clientes,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/equipes/',
	      	name: 'Equipes',
	      	meta: {
	      		title: 		"Equipes",
	      		icon: 		"la-users-cog",
		      	level: 		["admin"],
	      		auth: 		true,
	      	},
	      	component: Equipes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/equipes/cadastro',
	      	name: 'CadastrarEquipes',
	      	meta: {
	      		title: 		"Cadastrar equipes",
	      		icon: 		"la-users-cog",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarEquipes,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/equipes/editar',
	      	name: 'EditarEquipes',
	      	meta: {
	      		title: 		"Editar equipe",
	      		icon: 		"la-users-cog",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarEquipes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/planejamentos/',
	      	name: 'Planejamentos',
	      	meta: {
	      		title: 		"Planejamentos",
	      		icon: 		"la-tasks",
		      	level: 		["admin"],
	      		auth: 		true,
	      	},
	      	component: Planejamentos,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/planejamentos/cadastro',
	      	name: 'CadastrarPlanejamentos',
	      	meta: {
	      		title: 		"Cadastrar planejamento",
	      		icon: 		"la-tasks",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarPlanejamentos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/planejamentos/editar',
	      	name: 'EditarPlanejamentos',
	      	meta: {
	      		title: 		"Editar planejamento",
	      		icon: 		"la-tasks",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarPlanejamentos,
	      	beforeEnter: checkLogin,
	    }, 
	    {
	      	path: '/planejamentos/detalhes',
	      	name: 'DetalhesPlanejamentos',
	      	meta: {
	      		title: 		"Detalhes do planejamento",
	      		icon: 		"la-tasks",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: DetalhesPlanejamentos,
	      	beforeEnter: checkLogin,
	    }, 	    
	    {
	      	path: '/faturamentos/',
	      	name: 'Faturamentos',
	      	meta: {
	      		title: 		"Faturamento",
	      		icon: 		"la-money-bill",
		      	level: 		["admin"],
	      		auth: 		true,
	      	},
	      	component: Faturamentos,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/faturas/',
	      	name: 'Faturas',
	      	meta: {
	      		title: 		"Faturas",
	      		icon: 		"la-dollar-sign",
		      	level: 		["admin","contratante"],
	      		auth: 		true,
	      	},
	      	component: Faturas,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/contratos/',
	      	name: 'Contratos',
	      	meta: {
	      		title: 		"Contratos",
	      		icon: 		"la-file-invoice-dollar",
		      	level: 		["admin"],
	      		auth: 		true,
	      	},
	      	component: Contratos,
	      	beforeEnter: checkLogin,
	    },	  
	    {
	      	path: '/notas-fiscais/',
	      	name: 'NotasFiscais',
	      	meta: {
	      		title: 		"Notas Fiscais",
	      		icon: 		"la-file",
		      	level: 		["admin", "contratante"],
	      		auth: 		true,
	      	},
	      	component: NotasFiscais,
	      	beforeEnter: checkLogin,
	    },	  	      
	    {
	      	path: '/visitas/',
	      	name: 'Visitas',
	      	meta: {
	      		title: 		"Visitas",
	      		icon: 		"la-map-marker-alt",
		      	level: 		["admin", "prestador", "contratante"],
	      		auth: 		true,
	      	},
	      	component: Visitas,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/visitas/cadastro',
	      	name: 'CadastrarAgendamentos',
	      	meta: {
	      		title: 		"Agendar nova visita",
	      		icon: 		"la-calendar",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"]
	      	},
	      	component: GerenciarAgendamentos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/visitas/editar',
	      	name: 'EditarAgendamentos',
	      	meta: {
	      		title: 		"Visualizar visita",
	      		icon: 		"la-map-marker-alt",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "prestador"]
	      	},
	      	component: GerenciarAgendamentos,
	      	beforeEnter: checkLogin,
	    },   
	    {
	      	path: '/ordens-servicos/',
	      	name: 'OrdensServicos',
	      	meta: {
	      		title: 		"Ordens de Serviço",
	      		icon: 		"la-file-signature",
		      	level: 		["admin", "contratante"],
	      		auth: 		true,
	      	},
	      	component: OrdensServicos,
	      	beforeEnter: checkLogin,
	    },     	    
	    {
	      	path: '/usuarios/',
	      	name: 'Usuarios',
	      	meta: {
	      		title: 		"Usuários",
	      		icon: 		"la-users",
		      	auth: 		true,
		      	// backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar usuário",
		      		"cadastrarBotaoNome": 		"CadastrarUsuarios",
		      		"editarBotaoNome": 			"EditarUsuarios",
		      		"tipo": 					"admin,consultor,contratante,master" 
		      	}
	      	
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },		        
	    {
	      	path: '/usuarios/cadastro',
	      	name: 'CadastrarUsuarios',
	      	meta: {
	      		title: 		"Cadastrar usuário",
	      		icon: 		"la-users",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/usuarios/editar',
	      	name: 'EditarUsuarios',
	      	meta: {
	      		title: 		"Editar usuário",
	      		icon: 		"la-users",
		      	auth: 		true,
		      	backButton: true,
				level: 		["admin"],
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },		        
	    {
	      	path: '/contratos/cadastro',
	      	name: 'CadastrarContratos',
	      	meta: {
	      		title: 		"Cadastrar contrato",
	      		icon: 		"la-file-invoice-dollar",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: GerenciarContratos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/contratos/editar',
	      	name: 'EditarContratos',
	      	meta: {
	      		title: 		"Editar contrato",
	      		icon: 		"la-file-invoice-dollar",
		      	auth: 		true,
		      	backButton: true,
				level: 		["admin"],
	      	},
	      	component: GerenciarContratos,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/conta/',
	      	name: 'Conta',
	      	meta: {
	      		title: 		"Perfil do usuário",
	      		icon: 		"la-user",
		      	level: 		["admin", "contratante", "prestador"],
	      		auth: 		true,
	      	},
	      	component: Conta,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/configuracoes/',
	      	name: 'Configuracoes',
	      	meta: {
	      		title: 		"Configurações",
	      		icon: 		"la-cog",
		      	level: 		["admin"],
	      		auth: 		true,
	      	},
	      	component: Configuracoes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/pagamento/',
	      	name: 'Pagamento',
	      	meta: {
	      		title: 		"Efetuar pagamento",
	      		icon: 		"la-dollar-sign",
		      	level: 		["admin", "contratante"],
	      		auth: 		true,
	      	},
	      	component: Pagamento,
	      	beforeEnter: checkLogin,
	    },	          
	    {
	      	path: '/ordem-de-servico',
	      	name: 'OS',
	      	meta: {
	      		title: 		"Ordem de serviço",
		      	level: 		["admin", "contratante", "prestador"],
	      		auth: 		true,
	      	},
	      	component: OS,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/contrato',
	      	name: 'Contrato',
	      	meta: {
	      		title: 		"Contrato",
		      	level: 		["admin", "contratante", "prestador"],
	      		auth: 		true,
	      	},
	      	component: Contrato,
	      	beforeEnter: checkLogin,
	    },		    	    	            
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		// auth: 		false,
	      	},
	      	component: RecuperarSenha,
	      	beforeEnter: checkLogin,
	    },	          
	    { path: '*', redirect: '/dashboard/' }
  	]
})

const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".dashboard-content-inner")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".dashboard-content-inner")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	    	element.scrollTop = scrollPositions[currentRouteName];
	    	scrollPositions[currentRouteName] = null;
	  	}
	}, 100);
})

export default _this;



// WEBPACK FOOTER //
// ./src/router/index.js